import React from "react";
import Toggle from "../../../../atoms/Forms/Toggle";

import styles from "./MainApp.organisms.Product.Details.FormDisableProduct.module.scss";
import i18n from "i18n";

export class FormEditProduct extends React.Component {
  render() {
    const { product, handleChange } = this.props;

    return (
      <div
        className={styles["disable-product-container"]}
        data-automation-id="disable-product-container"
      >
          <p className={styles["disable-product-label"]}>
            {i18n.t("product")} <span className={styles["disable-product-label-span"]}>{product.enabled ? i18n.t("enabled").toLowerCase() : i18n.t("disabled").toLowerCase()}</span>  {i18n.t("to.carry.out.operations")}
          </p>
          <div className={styles["disable-product-toggle"]}>
            <Toggle handleChange={handleChange} checked={product.enabled} name={'enabled'} ></Toggle>
          </div>
      </div>
    );
  }
}

export default FormEditProduct;
